export const view = {
    isMobile: false
}